import { axiosInstance } from '@/utils/api'
import { ISupplier } from '@/utils/types/model/supplier'

interface ISupplierListResponse {
  totalRecords: number
  suppliers: ISupplier[]
}

export async function getSuppliers(
  page: number,
  limit: number,
  supplierCode?: string,
  sortBy?: string,
  sortType?: string
): Promise<ISupplierListResponse> {
  const params: Record<string, unknown> = {
    page,
    limit,
  }

  if (supplierCode) {
    params.code = supplierCode
  }

  if (sortBy) {
    params.sortBy = sortBy
  }

  if (sortType) {
    params.sortType = sortType
  }

  const response = await axiosInstance.get('/suppliers', { params })
  return response.data
}

export async function exportSuppliers(data: { sortBy?: string; sortType?: string }) {
  const response = await axiosInstance.post('/suppliers/export', data)
  return response.data
}
